import { NavLink } from "react-router-dom";

export interface SectionTab {
  to: string;
  label: string;
  // Only the section root needs an exact match; children match by prefix.
  end?: boolean;
}

// One sub-navigation shared by every section, so a split screen reads as one
// place with several views rather than as unrelated pages.
export function SectionTabs({ tabs }: { tabs: SectionTab[] }) {
  return (
    <nav className="section-tabs" aria-label="Views">
      {tabs.map((tab) => <NavLink to={tab.to} end={tab.end} key={tab.to}>{tab.label}</NavLink>)}
    </nav>
  );
}
